import { BillingDataService } from './../data-services/billing-data.service';
import { AlertService } from '@mapfre-design-library/src/public_api';
import { UserDetailsService } from './user-details.service';
import { StorageServiceObservablesService } from './../storage-service-observables/storage-service-observables.service';
import { BankAccountService } from './bank-account.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { PaperlessService } from '../_iam/paperless.service';
import { ProfileConfirmModalService } from './profile-confirm-modal.service';

@Injectable({
  providedIn: 'root',
})
export class UnenrollmentConfirmModalService {
  public hideModalOnRoute = false;
  private checkDirty = new BehaviorSubject<boolean>(false);
  $checkDirty = this.checkDirty.asObservable();
  private removeAccount = new BehaviorSubject<boolean>(false);
  $removeAccount = this.removeAccount.asObservable();
  previousURL: any;

  constructor(
    public router: Router,
    private bankAccountService: BankAccountService,
    private storageService: StorageServiceObservablesService,
    private userDetailsService: UserDetailsService,
    private alertService: AlertService,
    private paperlessService: PaperlessService,
    private billingDataService: BillingDataService,
    private profileConfirmModalService: ProfileConfirmModalService
  ) {}
  onRemoveCheckingAccount(removeAccount: string) {
    this.hideModalOnRoute =
      this.profileConfirmModalService.onRemoveCheckingAccount(removeAccount);
  }

  onRestoreDefault() {
    this.checkDirty.next(false);
    this.removeAccount.next(false);
  }
}
